"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Award, BookOpen, HeartHandshake, ShieldCheck, Stethoscope } from "lucide-react";
export default function SafetyFirst() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const certifications = [{
    name: "Background Checked",
    icon: HeartHandshake
  }, {
    name: "Youth Safety Certified",
    icon: Award
  }, {
    name: "First Aid Trained",
    icon: ShieldCheck
  }, {
    name: "Emergency Prepared",
    icon: Stethoscope
  }, {
    name: "Community Verified",
    icon: BookOpen
  }];
  const stats = ["15+ Weekly Programs", "10 Years Empowering", "Annual Safety Audits"];
  return <section data-section-id="969" id="safety-first" className="dark bg-background border-t border-b border-border py-24 md:py-32 px-6">
      <div ref={ref} className={`mx-auto max-w-[960px] text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary mb-6">
          Vetted. Secure. Trusted.
        </p>

        {}
        <h2 className="font-serif font-default text-3xl sm:text-4xl md:text-[44px] leading-tight text-foreground tracking-tight">
          Building a secure environment for every member.
        </h2>

        {}
        <div className="mt-14 md:mt-16">
          <ul className="flex flex-wrap items-start justify-center gap-x-8 gap-y-10 md:gap-x-12">
            {certifications.map((cert, i) => {
            const Icon = cert.icon;
            return <li data-index={i} key={cert.name} className="group flex flex-col items-center gap-3 w-[140px] opacity-70 hover:opacity-100 transition-opacity duration-300">
                  <div className="flex h-14 items-center justify-center">
                    <Icon className="h-12 w-12 text-foreground/70 group-hover:text-primary transition-colors duration-300" strokeWidth={1.25} />
                  </div>
                  <span className="font-mono text-[11px] tracking-[0.12em] uppercase text-muted-foreground group-hover:text-foreground transition-colors duration-300 leading-snug">
                    {cert.name}
                  </span>
                </li>;
          })}
          </ul>
        </div>

        {}
        <div className="mt-14 md:mt-16">
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-3 text-sm md:text-[15px] text-muted-foreground">
            {stats.map((stat, i) => <li data-index={i} key={stat} className="flex items-center gap-4 font-default">
                <span>{stat}</span>
                {i < stats.length - 1 && <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-lg bg-primary" />}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}